'use strict';

function LoanProcessMobile() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.analytics = new Analytics();

  this.init = function () {
    this._super(); // Requires setup of computed variables
    this.analytics.forcePushEvent('virtual-page-view');
  };

  this.initAllReady = function () {
    this._super(); // Requires setup of computed variables
  };

  this.initPage = function () {};

  this.destroy = function () {};
}